import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  secondaryPassword: string;
  onChangeSecondaryPassword: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const ConfirmLoginPasswordInputFieldComponent = (props: Props) => {
  const { t } = useTranslation();
  return (
    <div className="field">
      <label className="label has-text-centered is-unselectable">{t("confirmPassword")}</label>
      <input
        className="input"
        type="password"
        value={props.secondaryPassword}
        onChange={props.onChangeSecondaryPassword}
      />
    </div>
  );
};
